module.exports = __webpack_public_path__ + "img/img-side.b3fb2771.png";